import { PolicyStatus } from '@/types/policy'

export const StatusLabels = {
  [PolicyStatus.Active]: { label: 'Активен', color: 'green' },
  [PolicyStatus.Expired]: { label: 'Истек', color: 'orange' },
  [PolicyStatus.CopayBlocked]: { label: 'Франшиза заблокирована', color: 'red' },
  [PolicyStatus.WithoutCopay]: { label: 'Без франшизы', color: 'secondary' },
}